/**
 * Formatea una cédula dominicana al formato XXX-XXXXXXX-X
 * @param {string} value - Valor de entrada
 * @returns {string} - Cédula formateada
 */
export const formatCedula = (value) => {
  // Remover todo excepto números
  const numbers = value.replace(/\D/g, '');

  // Limitar a 11 dígitos
  const limited = numbers.slice(0, 11);

  // Aplicar formato XXX-XXXXXXX-X
  if (limited.length <= 3) {
    return limited;
  } else if (limited.length <= 10) {
    return `${limited.slice(0, 3)}-${limited.slice(3)}`;
  } else {
    return `${limited.slice(0, 3)}-${limited.slice(3, 10)}-${limited.slice(10)}`;
  }
};

/**
 * Limpia una cédula removiendo guiones
 * @param {string} cedula - Cédula formateada
 * @returns {string} - Cédula sin guiones
 */
export const cleanCedula = (cedula) => {
  return cedula.replace(/\D/g, '');
};

/**
 * Valida que una cédula tenga exactamente 11 dígitos
 * @param {string} cedula - Cédula a validar
 * @returns {boolean} - true si es válida
 */
export const isValidCedula = (cedula) => {
  const numbers = cleanCedula(cedula);
  return numbers.length === 11;
};
